<p>
    <ng-container *ngIf="!!data.icon && !data.svgIcon">
        <mat-icon>{{ data.icon }}</mat-icon>
    </ng-container>
    <ng-container *ngIf="!!data.svgIcon && !data.icon">
        <mat-icon [svgIcon]="data.svgIcon"></mat-icon>
    </ng-container>
    <span class="text" *ngIf="!!data.msg">{{ data.msg }}</span>
</p>